import { Component, OnInit } from '@angular/core'
import { versionWeb } from '../../../helper/common'

@Component({
    selector: 'app-login-account',
    templateUrl: './login-account.component.html',
    styleUrls: ['./login-account.component.css'],
})
export class LoginAccountComponent implements OnInit {
    versionWeb = versionWeb
    errorText = ''

    constructor() {
    }

    ngOnInit() {
    }

    sendRequest(id, password) {
        //console.log(id);
        //console.log(password);
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/login-account/login-account.component.ts